module.exports = __webpack_public_path__ + "static/media/sort-alt.665a09cc.svg";